export const initialState = {
	isChecking: {},
	hasChecked: {},
	hasUserData: {},
	errorMessages: {},
};

export default initialState;
